/**
 * Inline SVG icon set, replacing the Material Icons webfont in the revamped
 * screens. Every icon takes className so size and colour come from Tailwind.
 */
import React from "react";

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  viewBox: "0 0 24 24",
};

const Icon = (props) => <svg {...stroke} {...props} />;

// --- navigation -------------------------------------------------------------
export const HomeIcon = (p) => (
  <Icon {...p}>
    <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
  </Icon>
);
export const CalendarIcon = (p) => (
  <Icon {...p}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M8 3v4M16 3v4M3 10h18" />
  </Icon>
);
export const ClockIcon = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 3" />
  </Icon>
);
export const BellIcon = (p) => (
  <Icon {...p}>
    <path d="M15 17h5l-1.4-1.4A2 2 0 0118 14.2V11a6 6 0 00-4-5.66V5a2 2 0 10-4 0v.34A6 6 0 006 11v3.2a2 2 0 01-.6 1.4L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
  </Icon>
);
export const UsersIcon = (p) => (
  <Icon {...p}>
    <path d="M17 20v-1a4 4 0 00-4-4H7a4 4 0 00-4 4v1M9 11a4 4 0 100-8 4 4 0 000 8zm11 9v-1a3.5 3.5 0 00-2.5-3.36M15 4.13a3.5 3.5 0 010 6.74" />
  </Icon>
);
export const SettingsIcon = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 008 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06A1.65 1.65 0 004.6 15a1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 4.6a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z" />
  </Icon>
);
export const GridIcon = (p) => (
  <Icon {...p}>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </Icon>
);
export const MenuIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Icon>
);
export const MoreIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <circle cx="5" cy="12" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="19" cy="12" r="1.4" fill="currentColor" stroke="none" />
  </Icon>
);

// --- chevrons & arrows ------------------------------------------------------
export const ChevronDownIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M6 9l6 6 6-6" />
  </Icon>
);
export const ChevronUpIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M18 15l-6-6-6 6" />
  </Icon>
);
export const ChevronLeftIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M15 19l-7-7 7-7" />
  </Icon>
);
export const ChevronRightIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M9 5l7 7-7 7" />
  </Icon>
);
export const ArrowLeftIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M10 19l-7-7 7-7M3 12h18" />
  </Icon>
);

// --- actions ----------------------------------------------------------------
export const PlusIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M12 4v16m8-8H4" />
  </Icon>
);
export const CloseIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Icon>
);
export const PencilIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.5-9.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 8.5-8.5z" />
  </Icon>
);
export const TrashIcon = (p) => (
  <Icon {...p}>
    <path d="M4 7h16M10 11v6M14 11v6M5 7l1 13a1 1 0 001 1h10a1 1 0 001-1l1-13M9 7V4h6v3" />
  </Icon>
);
export const ReplayIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M4 4v5h5M20 20v-5h-5" />
    <path d="M19.4 9A7.5 7.5 0 006.3 6.3L4 9m0 6a7.5 7.5 0 0013.1 2.7L20 15" />
  </Icon>
);
export const SearchIcon = (p) => (
  <Icon {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </Icon>
);
export const FilterIcon = (p) => (
  <Icon {...p}>
    <path d="M3 5h18M6 12h12M10 19h4" />
  </Icon>
);
export const SortIcon = (p) => (
  <Icon {...p}>
    <path d="M7 4v16m0 0l-3-3m3 3l3-3M17 20V4m0 0l-3 3m3-3l3 3" />
  </Icon>
);
export const LogoutIcon = (p) => (
  <Icon {...p}>
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
  </Icon>
);
export const UserIcon = (p) => (
  <Icon {...p}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4.5 20a7.5 7.5 0 0115 0" />
  </Icon>
);
export const MailIcon = (p) => (
  <Icon {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </Icon>
);
export const MailUnreadIcon = (p) => (
  <Icon {...p}>
    <path d="M3 8.5V19a2 2 0 002 2h14a2 2 0 002-2V8.5" />
    <path d="M3 8.5l9 6 4.2-2.8M3 8.5V7a2 2 0 012-2h8.2" />
    <circle cx="19" cy="6" r="3" fill="currentColor" stroke="none" />
  </Icon>
);

// --- status -----------------------------------------------------------------
export const SyncIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
  </Icon>
);
export const SyncProblemIcon = (p) => (
  <Icon {...p} strokeWidth={2}>
    <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    <path d="M12 9v3.5M12 16h.01" />
  </Icon>
);
export const CheckIcon = (p) => (
  <Icon {...p} strokeWidth={2.4}>
    <path d="M5 13l4 4L19 7" />
  </Icon>
);
export const AlertIcon = (p) => (
  <Icon {...p}>
    <path d="M12 9v3.75m0 3.75h.007M10.29 3.86L1.82 18a1.5 1.5 0 001.29 2.25h17.78A1.5 1.5 0 0022.18 18L13.71 3.86a1.5 1.5 0 00-2.42 0z" />
  </Icon>
);
export const WifiIcon = (p) => (
  <Icon {...p}>
    <path d="M5 12.5a11 11 0 0114 0M8 16a6.5 6.5 0 018 0" />
    <path d="M12 19.5h.01" strokeWidth={2.4} />
  </Icon>
);
export const DeviceIcon = (p) => (
  <Icon {...p}>
    <rect x="4.5" y="4.5" width="15" height="15" rx="2.5" />
    <path d="M8.25 3v1.5M15.75 3v1.5M8.25 19.5V21M15.75 19.5V21M3 8.25h1.5M3 12h1.5M3 15.75h1.5M19.5 8.25H21M19.5 12H21M19.5 15.75H21" />
  </Icon>
);
